import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  clients: [],
  error: null,
  message: '',
};
const ctcMasterReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPLOAD_CTC_MASTER_REQUEST:
    case actionTypes.GET_CTC_MASTER_REQUEST:
    case actionTypes.UPDATE_CTC_MASTER_REQUEST:
    case actionTypes.DELETE_CTC_MASTER_REQUEST:
    case actionTypes.MULTI_DELETE_CTC_MASTER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.UPLOAD_CTC_MASTER_SUCCESS:
    case actionTypes.UPDATE_CTC_MASTER_SUCCESS:
    case actionTypes.DELETE_CTC_MASTER_SUCCESS:
    case actionTypes.MULTI_DELETE_CTC_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        message: action.payload,
      };
    case actionTypes.GET_CTC_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: action.payload,

      }


    case actionTypes.GET_CTC_MASTER_SUCCESS:
      return {
        ...state,
        loading: false,
        clients: action.payload,
      };

    case actionTypes.UPLOAD_CTC_MASTER_FAILURE:
    case actionTypes.GET_CTC_MASTER_FAILURE:
    case actionTypes.UPDATE_CTC_MASTER_FAILURE:
    case actionTypes.DELETE_CTC_MASTER_FAILURE:
    case actionTypes.MULTI_DELETE_CTC_MASTER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default ctcMasterReducer
